import { createContext, useCallback, useContext } from 'react';

import useInsightsGroupTypeManagement from 'components/insights/hooks/useInsightsGroupTypeManagement';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';
import { useNetworkPerformanceActions, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

import NetworkPerformancePage from './NetworkPerformancePage';

type NetworkPerformanceContextType = {
  profile: Profile;
  predecessorGroupType: GroupType | undefined;
  groupTypes: GroupType[];
  onTabChange: (groupType: GroupType) => void;
};

export const NetworkPerformanceContext = createContext<NetworkPerformanceContextType>({
  profile: {} as Profile,
  predecessorGroupType: undefined,
  groupTypes: [],
  onTabChange: () => {},
});

export const useNetworkPerformanceContext = () => useContext(NetworkPerformanceContext);

const buildGroupTypes = (managed: GroupType[], providedIds: Set<string>) =>
  managed.filter((gt) => !providedIds.has(gt.id));

const NetworkPerformanceContainer = () => {
  const selectedGroupType = useNetworkPerformanceStore((state) => state.selectedGroupType);
  const { setSelectedGroupType, setPredecessorGroupTypeId, resetFilters } = useNetworkPerformanceActions();

  const { profile, predecessorGroupType, groupTypes, handleTabChange } = useInsightsGroupTypeManagement({
    preferenceKey: 'networkPerformanceProviderType',
    buildGroupTypes: useCallback(buildGroupTypes, []),
    setSelectedGroupType,
    setPredecessorGroupTypeId,
    resetFilters,
    selectedGroupType,
  });

  return (
    <NetworkPerformanceContext value={{ profile, predecessorGroupType, groupTypes, onTabChange: handleTabChange }}>
      {predecessorGroupType && selectedGroupType && <NetworkPerformancePage />}
    </NetworkPerformanceContext>
  );
};

export default NetworkPerformanceContainer;
